export default __webpack_public_path__ + "static/media/background.ccaf4691.jpg";